// © Microsoft Corporation. All rights reserved.

import { DarkModeBackgroundColor, LightModeBackgroundColor } from "@msnews/experiences-base";
import { DesignSystem, isDarkMode, neutralForegroundRest } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { enums } from "../../../../utils/enums";

const tabItemVerticalPadding = 13;
const tabItemIconSize = 18;

export const ProfileTabsSuperAppStyles = (config: DesignSystem) => ({
    profileTabsSuperAppContainer: {
        "min-width": "320px",
        margin: "0px 3px 16px",
        background: "inherit",
        "box-shadow": "none",

        "& .cwt-profile-tabs": {
            background: "inherit",
            "min-height": `${2 * tabItemVerticalPadding + tabItemIconSize}px`,
            "border-bottom": "none",
            padding: "0 16px",
            top: "-30px", // Profile page padding
            "& .cwt-tab-item:hover": {
                background: "none"
            },

            "&.demo": {
                top: "-30px" // Profile page padding
            },

            "& .cwt-tab-item": {
                padding: `${tabItemVerticalPadding}px 60px`,
                margin: "0 3px",

                "&.active": {

                    "&:after": {
                        background: "#F6F9FF",
                        "border-radius": "1.5px",
                        opacity: "0.8",
                        "margin-top": "calc(13px - 3px)"
                    },

                    "& .cwt-icon-label": {
                        color: "white",
                        opacity: "1",
                        "font-weight": "500"
                    }
                },

                "& .cwt-icon": {
                    "text-transform": "uppercase",
                    [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "0",

                    "& .cwt-icon-vector": {
                        display: "none"
                    }
                },

                "& .cwt-icon-label": {
                    color: "white",
                    opacity: "0.6",
                    "font-size": "13px",
                    "font-weight": "500",
                    padding: "0",

                    "&:before": {
                        width: "0"
                    }
                }
            }
        },
        "& .cwt-tab-content": {
            background: isDarkMode(config) ? DarkModeBackgroundColor : LightModeBackgroundColor,
            "border-radius": "0",
            "flex-grow": "1",
            "padding-top": "16px"
        },

        ["&." + enums.responsiveLevels.L0]: {
            "& .cwt-profile-tabs": {
                top: "-30px", // Profile page padding
                "& .cwt-tab-item": {
                    padding: `${tabItemVerticalPadding}px 9px`
                }
            },
            "& .cwt-tab-content": {
                background: isDarkMode(config) ?  "#181818" : "#FFFFFF",
                "border-radius": "20px 20px 0 0",
                "padding-top": "0"
            }
        }
    },
    profileLockedSuperAppContainer: {
        "border-radius": "20px 20px 0 0",
        background: isDarkMode(config) ?  "#181818" : "#FFFFFF",
        "margin-top": "20px",
        height: "70vh",
        display: "flex",
        "flex-direction": "column",
        "justify-content": "center",
        "align-items": "center",
        padding: "0 0px 12vw",
        "flex-grow": "1",

        "& .cwt-message": {
            "margin-top": "16px",
            "font-size": "15px",
            "line-height": "20px",
            color: neutralForegroundRest
        }
    },

    profileEmptyTabSuperAppContainer: {
        "padding-left": "16px",
        "padding-right": "16px",
        "flex-grow": "1"
    }
});